'use client'
import {
  minifyGqlQuery
} from "./chunk-SQE4KWHX.mjs";
import {
  CARD_QUERY
} from "./chunk-ZJBMFTE6.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-IIMDQLWJ.mjs";
import {
  gqlClient
} from "./chunk-4T365VQK.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/api/cards/listing.ts
import {
  useInfiniteQuery,
  useQuery
} from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
import { gql } from "graphql-request";
var getCards = (_a) => __async(null, null, function* () {
  var _b = _a, {
    contentLimit = 100,
    contentSkip = 0
  } = _b, props = __objRest(_b, [
    "contentLimit",
    "contentSkip"
  ]);
  try {
    const res = yield gqlClient.request(
      minifyGqlQuery(gql`
        query getWebCard(
          $lang: String
          $limit: Int
          $skip: Int
          $where: WebCardFilter
        ) {
          webCardCollection(locale: $lang, limit: $limit, skip: $skip, where: $where) {
            items {
              __typename
              ${CARD_QUERY}
            }
          }
        }
      `),
      __spreadProps(__spreadValues({}, props), {
        limit: contentLimit,
        skip: contentSkip,
        lang: getContentfulSafeLocale(props.lang)
      })
    );
    return res.webCardCollection;
  } catch (error) {
    throw new Exception({ error, name: "getSectionByIdException" });
  }
});
var useCards = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["cards", props],
    queryFn: () => getCards(props)
  }, options));
};
var useCardsPaginated = (_a) => {
  var _b = _a, {
    options
  } = _b, props = __objRest(_b, [
    "options"
  ]);
  return useInfiniteQuery(__spreadProps(__spreadValues({
    queryKey: ["cardsPaginated", props],
    queryFn: ({ pageParam }) => getCards(__spreadProps(__spreadValues({}, props), {
      contentSkip: pageParam,
      contentLimit: props.contentLimit || 10
    })),
    getNextPageParam: (lastPage, allPages) => {
      const lastPageItems = lastPage.items || [];
      const limit = props.contentLimit || 10;
      return lastPageItems.length === limit ? allPages.length * limit : void 0;
    },
    initialPageParam: options.initialPageParam || 0
  }, options), {
    select(data) {
      return data.pages.flatMap((page) => page.items);
    }
  }));
};

export {
  useCards,
  useCardsPaginated
};
//# sourceMappingURL=chunk-5DDVDLZW.mjs.map